import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { NotificationService } from 'src/app/Service/notification.service';
import { GlobalConstants } from 'src/app/utils/global-constants';

@Component({
    selector: 'app-get-started-box',
    templateUrl: './get-started-box.component.html',
    styleUrls: ['./get-started-box.component.css'],
    standalone: false
})
export class GetStartedBoxComponent {
  emailForm: FormGroup;
  constructor(
    private router: Router,
    private notify: NotificationService,
    private formBuilder: FormBuilder
  ) {
    this.emailForm = this.formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.pattern(GlobalConstants.emailPattern)],
      ],
    });
  }
  goToOnboard() {
    if (this.emailForm.valid) {
      const navigationExtras: NavigationExtras = {
        state: {
          email: this.emailForm.get('email').value,
        },
      };
      this.router.navigateByUrl('/signup-type', navigationExtras);
    } else {
      this.notify.showWarning('Please fill in the email field.');
    }
  }
}
